import TopSectionWithoutFilter from '@/TRC/components/TopSections/topSectionWithoutFilter';
import TRCHorizontalScrollComponent from '@/TRC/components/horizontalDivComponent';
import TRC_PAGE_CATEGORIES from '@/TRC/constants/trcCategories';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';
import { useLocation } from 'react-router-dom';

const getCreatedAtTime = item => {
	const time = new Date(item?.createdAt || item?.updatedAt || 0).getTime();
	return Number.isNaN(time) ? 0 : time;
};

const TRCProgressiveLessonsSection = ({ lessonPlans = [], progressiveLessonPlans = [] }) => {
	const { pathname } = useLocation();
	const isStudioHub = pathname.startsWith(TRC_ROUTES.STUDIO_HUB_HOME);
	const lessonPlanBasePath = isStudioHub
		? 'studio-hub/lesson-plans'
		: 'trc/lesson-plans';
	const progressiveBasePath = isStudioHub
		? 'studio-hub/progressive-lesson-plans'
		: 'trc/progressive-lesson-plans';
	const trcLessonPlans = lessonPlans.map(plan => ({
		...plan,
		route: TRC_ROUTES.LESSON_PLANS,
		basePath: lessonPlanBasePath
	}));
	const studioLessonPlans = progressiveLessonPlans.map(plan => ({
		...plan,
		fileType: 'pdf',
		route: TRC_ROUTES.PROGRESSIVE_LESSON_PLANS,
		basePath: progressiveBasePath,
		categoryDetails: [
			{ _id: 'studio-lesson-plan', name: 'Progressive Lesson Plan', color: '#008bc3' },
			...(plan.categoriesDetails || [])
		]
	}));
	const combinedLessonPlans = [...trcLessonPlans, ...studioLessonPlans].sort(
		(a, b) => getCreatedAtTime(b) - getCreatedAtTime(a)
	);

	return (
		<section style={{ background: '#27272a' }}>
			<TopSectionWithoutFilter category={TRC_PAGE_CATEGORIES.LESSON_PLANS} />
			<TRCHorizontalScrollComponent
				contents={combinedLessonPlans}
				route={TRC_ROUTES.LESSON_PLANS}
				basePath={lessonPlanBasePath}
				className="px-lg-5"
				fixedWidth
			/>
		</section>
	);
};

export default TRCProgressiveLessonsSection;
